import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiDeleteLeasingPlan } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useDeleteLeasingPlanMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();

    const { mutate, isPending, error, isSuccess } = useMutationWithCartRefresh(
        async () => {
            const { data: cart } = await apiDeleteLeasingPlan(segment, { cartId });

            return cart;
        },
        {
            mutationKey: [ESHOP_MUTATION_KEY.DELETE_LEASING_PLAN],
        },
    );

    return {
        deleteLeasingPlan: mutate,
        deleteLeasingPlanIsLoading: isPending,
        deleteLeasingPlanIsSuccess: isSuccess,
        deleteLeasingPlanError: error,
    };
};
